import React from 'react';
import { TooltipCommonProps } from '../common';

export interface AddItemProps {
  /** any renderable node or a render function. In case of a render function, text styles will not be applied. */
  children?: React.ReactNode | (() => React.ReactNode);
  /** apply disabled styles */
  disabled?: boolean;
  /** the theme of component */
  theme?: AddItemTheme;
  /** switching content alignment  */
  alignItems?: AddItemAlignItems;
  /** size to control icon and spacing  */
  size?: AddItemSize;
  /** click event handler  */
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  /** Applied as data-hook HTML attribute that can be used to create driver in testing */
  dataHook?: string;
  /** A css class to be applied to the component's root element */
  className?: string;
  /** When provided, hover will display a tooltip */
  tooltipContent?: React.ReactNode;
  /** Tooltip props
   * @linkTypeTo components-overlays--tooltip
   */
  tooltipProps?: TooltipCommonProps;
  /** Displays the plus icon */
  showIcon?: boolean;
  /** Removes padding */
  removePadding?: boolean;
  /** sets the border-radius css property on the button element */
  borderRadius?: React.CSSProperties['borderRadius'];
  /** Defines a string value that labels the add item element */
  ariaLabel?: string;
  /** Subtitle of the component */
  ariaLabelledBy?: string;
  /** Subtitle of the component */
  subtitle?: React.ReactNode;
  /** The illustraion icon src or node */
  icon?: React.ReactNode;
}

export interface AddItemActions {
  blur: () => void;
  focus: () => void;
}

export type AddItemTheme = 'dashes' | 'plain' | 'filled' | 'image';
export type AddItemAlignItems = 'center' | 'right' | 'left';
export type AddItemSize = 'large' | 'medium' | 'small' | 'tiny';
